export const FORM_GUIDE_PATH = "/form-guide";

function cleanPath(pathname: string) {
  return pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
}

export function isGuidePath(pathname: string) {
  const path = cleanPath(pathname);
  return (
    path === FORM_GUIDE_PATH || path === "/guide" || path.startsWith("/guide/")
  );
}

export { cleanPath };
